import React from 'react'

import { PhotoThumbnail } from '@components/common/PhotoThumbnail'
import { QuantityBadge } from '@components/common/QuantityBadge'
import { StatusTag } from '@components/common/StatusTag'
import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { TableItemDate } from '@components/utils/TableItemDate'
import { getOrderImageUrl } from '@components/utils/getOrderImageUrl'
import { PriceString, ProfitString, Tag } from '@fourthwall/components'
import { getNumberOfProducts } from '@utils/products'

import type { Order } from '../../types'
import { getBackerName } from '../../utils/getBackerName'
import * as S from './OrderListItem.styled'

type OrderListItemProps = {
  order: Order
}

export const OrderListItem = ({ order }: OrderListItemProps) => {
  const { hasPermission } = useDashboardPermissions()
  const quantity = getNumberOfProducts(order.offers, order.donation)

  return (
    <S.Container>
      <S.Photo>
        <PhotoThumbnail
          url={getOrderImageUrl(order.offers, order.offersCancelled)}
          size="extraLarge"
        />
        {quantity > 0 && <QuantityBadge quantity={quantity} />}
      </S.Photo>
      <S.Details>
        <S.Supporter>{getBackerName(order)}</S.Supporter>
        <S.Date>
          <TableItemDate date={order.createdAt} />
        </S.Date>

        <StatusTag status={order.status} />
        {order.salesChannel.type === 'TikTok' && <Tag label="From TikTok" />}
      </S.Details>
      <S.Calculations>
        <PriceString value={order.totalPrice.value} />
        {hasPermission('contributions.profit') && order.profit && (
          <S.Profit>
            <ProfitString value={order.profit.value} />
          </S.Profit>
        )}
      </S.Calculations>
    </S.Container>
  )
}
